// extracted by mini-css-extract-plugin
module.exports = {"full-width-image":"styles_full-width-image__yfQOT"};